import { message } from 'antd';
// 私有属性，只在当前文件可用
const showMessage = Symbol('showMessage');
export default class DomMessage {
  state = {
    show: true,
  };

  onClose = () => {
    this.state.show = true;
  };

  success(options) {
    this[showMessage]('success', options);
  }

  warning(options) {
    this[showMessage]('warning', options);
  }

  info(options) {
    this[showMessage]('info', options);
  }

  error(options) {
    this[showMessage]('error', options);
  }

  [showMessage](type, options) {
    if (this.state.show) {
      this.state.show = false;
      message[type](options, 3, this.onClose);
    }
  }
}
